import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // 如果用户已认证，重定向到仪表盘
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error('请填写所有必填字段');
      return;
    }

    // 验证邮箱格式
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('请输入有效的邮箱地址');
      return;
    }

    setLoading(true);
    try {
      const result = await login(email, password);
      
      if (result.success) {
        toast.success('登录成功');
        navigate('/dashboard');
      } else {
        toast.error(result.error || '登录失败');
      }
    } catch (error) {
      toast.error('登录失败，请稍后重试');
      console.error('登录失败:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-xl overflow-hidden">
        <div className="p-6 sm:p-8">
          <div className="text-center mb-8">
            <div className="h-12 w-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="fa fa-shield text-white text-2xl"></i>
            </div>
            <h2 className="text-2xl font-bold text-gray-900">安全行业综合管理平台</h2>
            <p className="text-gray-500 mt-1">请登录您的账号</p>
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="form-label">邮箱</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="请输入您的邮箱地址"
                required
                disabled={loading}
              />
              <p className="text-xs text-gray-500 mt-1">使用邮箱登录，系统将自动识别您的企业和角色</p>
            </div>
            
            <div>
              <label htmlFor="password" className="form-label">密码</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                placeholder="请输入密码"
                required
                disabled={loading}
              />
            </div>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
                  disabled={loading}
                />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                  记住我
                </label>
              </div>
              
              <div className="text-sm">
                <Link to="#" className="text-primary hover:text-blue-700">
                  忘记密码?
                </Link>
              </div>
            </div>
            
            <div>
              <button
                type="submit"
                className="w-full btn-primary flex justify-center items-center"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="spinner mr-2"></div>
                    <span>登录中...</span>
                  </>
                ) : (
                  <span>登录</span>
                )}
              </button>
            </div>
            
            <div className="text-center text-sm text-gray-500">
              <p>
                没有账号？请联系管理员创建账号或{' '}
                <Link to="#" className="text-primary hover:text-blue-700">
                  申请试用
                </Link>
              </p>
            </div>
          </form>
          
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="text-center text-xs text-gray-500">
              <p>© 2024 昊天安全管理平台. 版权所有.</p>
              <p className="mt-1">版本 2.0.0</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;